export default __webpack_public_path__ + "static/media/przez_was.9448d298.svg";